import React from 'react'
import {connect} from 'react-redux'
import ButtonForm from "./ButtonForm";
import {getOrder, getOrderRequestData} from "../order/OrderReducers";
import {formValueSelector} from 'redux-form'
import {getCurrent} from "../steps/StepsReducers";
import {select, finish} from "../steps/StepsActions";
import {STEP_CREATE_ORDER} from "../steps/StepsContants";
import {receive} from '../result/ResultActions';
import './Button.css';
import html from 'react-escape-html'
import {UrlUtils} from "../utils/UrlUtils";
import {PAYMENT_METHODS, PAYPAL, APPLE_PAY} from '../common/PaymentMethodsConstants';
import {PaypalHelper} from '../helpers/PaypalHelper';
import {ApplePayHelper} from '../helpers/ApplePayHelper';
import {OrdersHttpService} from '../http/OrdersHttpService';

const ButtonContainer = ({order, state, select, finish, receive}) => {

  const previous = () => {
    select(STEP_CREATE_ORDER);
  };

  const onWidgetResult = (error, result) => {
    console.log('on widget result:', error, result);

    if (result) {
      if (result.executeRequired) return;

      let orderId;
      if (result && result.confirmUrl) {
        orderId = UrlUtils.getParamValue(result.confirmUrl, 'orderId');
      }
      if (result && result.orderId) {
        orderId = result.orderId;
      }

      OrdersHttpService.getOrder(orderId)
        .then(response => {
          receive(error, result, response);
          finish();
        });

    } else {
      receive(error, result, null);
      finish();
    }
  };

  const getConfigUrl = () => {
    let scriptTag = `<script src="${state.config.environment.widgetUrl}"></script>`;
    return html`${scriptTag}`;
  };

  const getOptionalParameters = () => {
    const selector = formValueSelector('button');
    const optionalParameters = selector(
      state, 'language', 'deviceIdent', 'product'
    );
    const paymentMethodsParameters = selector(state, 'paypal', 'applepay');

    if (optionalParameters.product === PAYPAL){
      optionalParameters.paypal = PaypalHelper.getOptionalParameters(paymentMethodsParameters.paypal);
    } else if (optionalParameters.product === APPLE_PAY) {
      optionalParameters.applepay = ApplePayHelper.getOptionalParameters(paymentMethodsParameters.applepay);
    }

    return optionalParameters;
  };

  const getOptionalParametersTemplate = () => {
    let optionalParameters = getOptionalParameters();
    let params = `var optionalParameters = ${JSON.stringify(optionalParameters, null, 2)};
`;
    if (optionalParameters.product === PAYPAL && formValueSelector('button')(state, 'paypal.paypalCallbacks')) {
      params += PaypalHelper.getCallbacksTemplate();
    } else if (optionalParameters.product === APPLE_PAY && formValueSelector('button')(state, 'applepay.applepayCallbacks')) {
      params += ApplePayHelper.getCallbacksTemplate()
    }

    return html`${params}`;
  };

  const getResultCallback = () => {
    const optionalParameters = getOptionalParameters();
    let callbackCode = '';

    if (optionalParameters.product === PAYPAL) {
      callbackCode = PaypalHelper.getResultCallbacksTemplate();
    } else if (optionalParameters.product === APPLE_PAY) {
      callbackCode = ApplePayHelper.getResultCallbacksTemplate();
    }

    return html`${callbackCode}`;
  };

  const getInitiWidget = () => {
    const selector = formValueSelector('button');
    const values = selector(state, 'merchantId', 'orderId');
    var body = state.order.orderRequestData;
    let params = `
PayEngineWidget.initAsButton(
  'button-widget-container',
  '${values.merchantId}',
  '${JSON.stringify(body)}'
  optionalParameters,
  resultCallback
);
    `;
    return html`${params}`;
  };

  let onSubmit = (values) => {
    var body = state.order.orderRequestData;

    window.PayEngineWidget.initAsButton(
      'button-widget-container',
      values.merchantId,
      body,
      getOptionalParameters(),
      onWidgetResult
    );
  };

  return (
    <div className="row">
      <div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <ButtonForm order={order} onSubmit={values => onSubmit(values)} onPrevious={previous} paymentMethods={PAYMENT_METHODS}/>
        </div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <h3>Configuration</h3>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getConfigUrl()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getResultCallback()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getOptionalParametersTemplate()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getInitiWidget()}></div>
        </pre>
          </blockquote>
        </div>
        <div>
          <div className="text-center">
            <hr/>
            <h3>Button Container</h3>
          </div>
          <div className="clearfix"></div>
          <hr/>
          <div className="row">
            <div className="col-lg-6 col-md-12 col-xs-12 text-center">
              <h5>The button will be loaded here (iframe)</h5>
              <div className="button-container">
                <div id="button-widget-container"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ButtonContainer.propTypes = {};

const mapStateToProps = (state) => ({
  order: getOrder(state),
  orderRequestData: getOrderRequestData(state),
  state: state,
  currentStep: getCurrent(state),
  config: state.app.config
});

export default connect(
  mapStateToProps,
  {select, finish, receive}
)(ButtonContainer);



// WEBPACK FOOTER //
// ./src/button/ButtonContainer.js